import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { AuthType, loadSession, VisitorStatus } from '@techstyle/redux-core';
import { autoLogin, autoLoginPasswordless } from './accountsModule';
import logger from './logger';
var debug = logger.extend('autoLoginExtension');
export var AutoLoginType = {
  CREDENTIALS: 1,
  PASSWORDLESS: 2
};
/**
 * AutoLogin extension that adds support for the app to detect the
 * standard altoken/alkey/alemail query params.
 *
 * @param {Object} options - The options for the auto login extension.
 * @param {Function} options.onAutoLoginError - The callback function to handle auto login errors.
 * @returns {Object} - The auto login extension object.
 */

export default function autoLoginExtension() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      onAutoLoginError = _ref.onAutoLoginError;

  return {
    id: 'autoLogin',
    redux: {
      modules: []
    },
    server: process.browser ? undefined : {
      init: function init() {
        require('./config');
      },
      configure: function configure(server) {
        var _require = require('./autoLoginMiddleware'),
            autoLoginMiddleware = _require["default"]; // Abundance of caution: ensure backwards compatibility if someone
        // upgrades `@techstyle/redux-core` without upgrading
        // `@techstyle/next-server`. TODO: This can be removed when everyone
        // is up to date.


        var addMiddleware = function addMiddleware(name, middleware) {
          if (server.useTracked) {
            server.useTracked(name, middleware);
          } else {
            server.use(middleware);
          }
        };

        addMiddleware('autoLoginMiddleware', autoLoginMiddleware());
      }
    },
    app: {
      getInitialProps: {
        enhance: function enhance(getInitialProps) {
          return /*#__PURE__*/function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref2) {
              var Component, ctx, _ctx$query, alToken, alKey, alEmail, _ctx$store, _ctx$store$getState, _ctx$store$getState$s, visitorStatus, authType, isPasswordlessLogin;

              return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      Component = _ref2.Component, ctx = _ref2.ctx;
                      _ctx$query = ctx.query, alToken = _ctx$query.altoken, alKey = _ctx$query.alkey, alEmail = _ctx$query.alemail;

                      if (!(alToken && alKey || alEmail)) {
                        _context.next = 26;
                        break;
                      }

                      _context.next = 5;
                      return ctx.store.dispatch(loadSession());

                    case 5:
                      _ctx$store$getState$s = (_ctx$store = ctx.store) === null || _ctx$store === void 0 ? void 0 : (_ctx$store$getState = _ctx$store.getState()) === null || _ctx$store$getState === void 0 ? void 0 : _ctx$store$getState.session, visitorStatus = _ctx$store$getState$s.visitorStatus, authType = _ctx$store$getState$s.authType;
                      isPasswordlessLogin = Boolean(alEmail);

                      if (!(visitorStatus === (VisitorStatus === null || VisitorStatus === void 0 ? void 0 : VisitorStatus.LOGGED_IN) && (authType === (AuthType === null || AuthType === void 0 ? void 0 : AuthType.CREDENTIALS) || authType === (AuthType === null || AuthType === void 0 ? void 0 : AuthType.GMS_LOGIN)))) {
                        _context.next = 11;
                        break;
                      }

                      debug('Session is already logged in, autologin params will be ignored.');
                      _context.next = 26;
                      break;

                    case 11:
                      _context.prev = 11;

                      if (!isPasswordlessLogin) {
                        _context.next = 17;
                        break;
                      }

                      _context.next = 15;
                      return ctx.store.dispatch(autoLoginPasswordless({
                        email: alEmail
                      }));

                    case 15:
                      _context.next = 19;
                      break;

                    case 17:
                      _context.next = 19;
                      return ctx.store.dispatch(autoLogin({
                        alToken: alToken,
                        alKey: alKey
                      }));

                    case 19:
                      _context.next = 26;
                      break;

                    case 21:
                      _context.prev = 21;
                      _context.t0 = _context["catch"](11);
                      onAutoLoginError && onAutoLoginError({
                        error: _context.t0,
                        ctx: ctx,
                        type: isPasswordlessLogin ? AutoLoginType.PASSWORDLESS : AutoLoginType.CREDENTIALS,
                        payload: alEmail ? {
                          alEmail: alEmail
                        } : {
                          alToken: alToken,
                          alKey: alKey
                        }
                      });
                      debug('%c!%c Error using autologin params: %s', 'color: red', '', _context.t0);
                      debug('Render will continue as if the params were not supplied.');

                    case 26:
                      return _context.abrupt("return", getInitialProps({
                        Component: Component,
                        ctx: ctx
                      }));

                    case 27:
                    case "end":
                      return _context.stop();
                  }
                }
              }, _callee, null, [[11, 21]]);
            }));

            return function (_x) {
              return _ref3.apply(this, arguments);
            };
          }();
        }
      }
    }
  };
}